"use client";

import Icon from "apps/website/components/base/Icon/Icon";
import ListItem from "apps/website/components/base/ListItem/ListItem";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import ConditionalCheckListItem from "apps/website/components/feature/ConditionalCheckList/ConditionalCheckListItem/ConditionalCheckListItem";
import Container from "apps/website/components/layout/Container/Container";
import Section from "apps/website/components/layout/Section/Section";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import SpurredLayout from "apps/website/layouts/Spurred";
import { getDefaultLayoutData } from "apps/website/utils/content/layout";

import MicroGallery from "../../feature/MicroGallery/MicroGallery";
import TextTitle from "../../base/Text/TextTitle/TextTitle";

import EnterDiscountSection from "./EnterDiscountSection";
import { influencerWelcomeGalleryImages } from "./gallery-images";

const ListRow = ({ text }: { text: string }) => (
  <ListItem component={ConditionalCheckListItem.name} className="mb-4">
    <div className="flex items-center">
      <div className="rounded-full bg-green mr-2 w-6 h-6">
        <Icon icon="tickHeavy" size="xsmall" />
      </div>
      <TextBody size={3} tag="span" color="default" >
        { text }
      </TextBody>
    </div>
  </ListItem>
);

const List = () => (
  <div>
    <ListRow text="Get 14 days of KatKin fresh food for FREE!" />
    <ListRow text="Delivered frozen, personalised to your cat." />
    <ListRow text="100% human-quality meat, gently cooked to preserve vital nutrients." />
  </div>
);

const DiscountCodeSection = () => (
  <Container
    size={"md"}
    className={"bg-white p-4 "}
  >
    <TextSubtitle size={1} color="default" align={"center"}>Enter your free box code</TextSubtitle>
    <Spacer size="lg"></Spacer>
    <TextBody align="center" size={3}>You can find this in the first message you received from us.</TextBody>
    <Spacer size="lg"></Spacer>
    <EnterDiscountSection />
  </Container>
);

export const SectionInfluencerWelcome = () => {
  const layoutData = getDefaultLayoutData();

  return (
    <SpurredLayout {...layoutData}>
      <Section component={"NewInfluencerPage"} theme={"light-grey"} className="min-h-screen">
        <Container size={"md"}>
          <MicroGallery preText="" title="" body="" images={influencerWelcomeGalleryImages.images} />
          <Spacer size="2xl" />
          <div className="flex flex-col items-center pb-14">
            <TextTitle align="center" size={3} whitespace={"balance"} tag="h1" color="default">Welcome to KatKin Influencer Club </TextTitle>
            <Spacer size="lg" />
            <List />
            <DiscountCodeSection />
          </div>
        </Container>
      </Section >
    </SpurredLayout>
  );
};
